import {css} from '@emotion/react'
import Button from './Button'

const text = {
    en: {
        headerText: `Start with Startpage!`,
        bodyText: `Put online safety and privacy on autopilot.`,
        buttonText: `Download Startpage`,
    },
    de: {
        headerText: `Starte durch mit Startpage!`,
        bodyText: `Online-Sicherheit und Datenschutz im Autopilot!`,
        buttonText: `Startpage herunterladen`,
    },
    nl: {
        headerText: `Start met Startpage!`,
        bodyText: `Zet online veiligheid en privacy op de automatische piloot.`,
        buttonText: `Startpage downloaden`,
    },
}

const CtaSection = ({experimentId, ctaType, overrideStyles, os, browser, languageCode}) => {
    const {headerText, bodyText, buttonText} = text[languageCode]
    return (
        <section
            className="section-2"
            css={css`
                background: linear-gradient(96.17deg, #ecfffd 13.38%, #e8eaff 85.76%);
                padding: 100px 2rem;
                position: relative;
                ${overrideStyles};
            `}
        >
            <div
                className="mask"
                css={css`
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;
                    background-image: url(/images/hex1.png);
                    background-size: cover;
                    background-repeat: no-repeat;
                `}
            />
            <div
                className="content"
                css={css`
                    max-width: 966px;
                    margin: 0 auto;
                    text-align: center;
                    position: relative;
                    z-index: 2;
                `}
            >
                <h2
                    css={css`
                        font-size: 40px;
                        font-weight: 800;
                        line-height: 54px;
                    `}
                >
                    {headerText}
                </h2>
                <p
                    css={css`
                        margin: 25px 0 35px;
                        font-size: 24px;
                    `}
                >
                    {bodyText}
                </p>
                <Button
                    text={buttonText}
                    experiment={experimentId}
                    ctaType={ctaType}
                    os={os}
                    browser={browser}
                    languageCode={languageCode}
                />
            </div>
        </section>
    )
}

export default CtaSection
